export default __webpack_public_path__ + "static/media/bg-1.0d668e70.png";